import { useQuery } from '@powersync/react';

import { queries } from '@flow/sync';

import { todayIn } from './model.js';

/** Today (`YYYY-MM-DD`) in the time zone of the user's preferences (Europe/Madrid by default). */
export function useToday(userId: string): string {
  const query = queries.userPreferences(userId);
  const { data } = useQuery<{ timezone: string | null }>(query.sql, query.params);
  return todayIn(data[0]?.timezone ?? null);
}
